import React from 'react'
import { connect } from 'react-redux'
import 'styles/d3/drawer.scss'
import { drawerActions } from 'store/drawer'

const delay = 150

class Drawer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { closing: false }
  }

  onCloseDrawer = func => {
    this.setState({ closing: true })
    setTimeout(() => {
      func()
      this.setState({ closing: false })
    }, delay)
  }

  render() {
    const {
      open,
      className,
      closeOnBackgroundClick,
      onCancel,
      closeDrawer,
      children,
      content,
    } = this.props
    const { closing } = this.state
    const _className = `d3-drawer drawer-${open ? 'open' : 'closed'}${
      className ? ` ${className}` : ''
    }`
    return (
      <div
        className={_className}
        onClick={() =>
          this.onCloseDrawer(
            closeOnBackgroundClick ? onCancel || closeDrawer : null,
          )
        }
      >
        <div
          onClick={e => e.stopPropagation()}
          className={`content${closing ? ' closing' : ''}`}
        >
          <i
            className='fa fa-times drawer clickable'
            onClick={() => this.onCloseDrawer(onCancel || closeDrawer)}
          />
          {children || content}
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  drawerActions,
)(Drawer)



// WEBPACK FOOTER //
// ./src/components/Drawer.js